import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-98ee4040"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-area" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      class: "button-primary",
      to: "/registration"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.localize('create.account')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      class: "button-primary",
      to: "/login"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.localize('login.button')), 1)
      ]),
      _: 1
    })
  ]))
}